<template>
    <div
        class="relative h-full w-full"
        :class="{
            'min-h-12': horizontal,
        }"
    >
        <div
            v-show="block?.ShowDividerLine"
            class="absolute top-1/2 right-0 left-0 h-px -translate-y-1/2 bg-(--border-neutral-subtle)"
            :class="{
                'lg:top-0 lg:bottom-0 lg:left-1/2 lg:h-auto lg:w-px lg:-translate-x-1/2 lg:translate-y-0': !horizontal,
            }"
        />
    </div>
</template>

<script setup>
    const props = defineProps({
        block: Object,
    })

    const horizontal = computed(() => {
        return props.block?.DividerLineOrientation === 'horizontal'
    })
</script>
